'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/number-is-nan/index.js
 ** module id = 618
 ** module chunks = 1
 **/